<template>
	<div>
		<div ref="modalInstance" 
			class="modal fade" :class="{ show: active, 'd-block': active }"
			tabindex="-1" role="dialog">
			<div class="modal-dialog modal-dialog-centered modal-lg" 
				role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="modalInstanceLabel" v-if="modalType !== 'delete' && modalType !== 'trans' ">
							{{ $t(instanceClass + ".label") }}
						</h5>
						<h5 class="modal-title" id="modalInstanceTransLabel" v-if="modalType == 'trans'">
							{{ $t("transcontent.label") }}
						</h5>
						
						<button
							type="button"
							class="close btn-lg"
							data-dismiss="modal"
							aria-label="Close"
							@click="modalToggle">
							<span aria-hidden="true" style="color:red;">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<b-container v-if="modalType !== 'delete' && modalType !== 'trans' ">
							<b-form ref="modalForm"
								id="modalForm" @submit.prevent="handleSubmit(dItemId)"
								enctype="multipart/form-data" autocomplete="off" >
								<!-- Flash -->
								<!-- <div v-if="msgError" class="alert alert-danger" role="alert" v-html="msgError" /> -->
								<div v-if="$store.getters.flash.msg" class="alert alert-danger" role="alert" v-html="$store.getters.flash.msg" />
								<div class="form-row">
									<div
										v-for="(attr, index) in dataMapShow.attrsList"
										:key="attr.attrName" :class="`${attr.attrCol} mb-1`"
										:style="{ display: attr.attrDisplay }" >

										<b-form-group
											:id="`label-${attr.attrName + '-' + index}`"
											:label=" $t(instanceClass + '.' + attr.attrName) +
											(attr.attrRequired ? '*' : '') " class="small mb-1">
											
											<!-- String -->
											<b-form-input v-if="attr.attrType == 'String' &&
												attr.attrName != 'geospatial'" 
												type="text" class="form-control"
												:id="`input-${attr.attrName}`" v-model="form[attr.attrName]"
												:placeholder="$t(instanceClass + '.' + attr.attrName)"
												:required="attr.attrRequired"
												:readonly="dataMapShow.readOnlyShow"
												:class="{'is-invalid': (v$.form[attr.attrName] && v$.form[attr.attrName].$error), 'is-valid':(v$.form[attr.attrName] && !v$.form[attr.attrName].$error && v$.form[attr.attrName].$dirty)}"
												aria-describedby="input-1-live-feedback"
											/>
											<!-- :state="getValidationState(validationContext)" -->
											<!-- TextArea -->
											<b-form-textarea v-if="attr.attrType == 'TextArea'"
												:id="`input-${attr.attrName}`"
												v-model="form[attr.attrName]" placeholder=""
												rows="6" max-rows="8"
												:required="attr.attrRequired" :readonly="dataMapShow.readOnlyShow"
												:class="{'is-invalid': (v$.form[attr.attrName] && v$.form[attr.attrName].$error), 'is-valid':(v$.form[attr.attrName] && !v$.form[attr.attrName].$error && v$.form[attr.attrName].$dirty)}"
												aria-describedby="input-1-live-feedback"
											/>
											<!-- Text A revoir avec TextArea -->
											<b-form-textarea v-if="attr.attrType == 'Text'"
												:id="`input-${attr.attrName + '-' + index}`"
												v-model="attr.attrValue"
												placeholder="" rows="6" max-rows="8"
												:required="attr.attrRequired"
												:readonly="dataMapShow.readOnlyShow"
												:class="{'is-invalid': (v$.form[attr.attrName] && v$.form[attr.attrName].$error), 'is-valid':(v$.form[attr.attrName] && !v$.form[attr.attrName].$error && v$.form[attr.attrName].$dirty)}"
												aria-describedby="input-1-live-feedback"
											/>

											
											<!-- <vue-editor 
												v-if="attr.attrType == 'ckeditor'"
												v-model="form[attr.attrName]"
												class="form-control" style="height: auto"
												:required="attr.attrRequired" :readonly="dataMapShow.readOnlyShow"
												:editorOptions="editorConfig"
											/> -->
											<!-- <ckeditor 
												v-if="attr.attrType == 'ckeditor'"
												v-model="form[attr.attrName]"
												class="form-control" style="height: auto"
												:required="attr.attrRequired" :readonly="dataMapShow.readOnlyShow"
												:config="editorConfig"

											/> -->
											
											<!-- geospatial -->
											<b-form-input v-if="attr.attrName == 'geospatial'"
												:id="`input-${attr.attrName}`" v-model="jsongeom"
												type="text" class="form-control"
												:placeholder="$t(instanceClass + '.' + attr.attrName)"
												:required="attr.attrRequired"
												:readonly="dataMapShow.readOnlyShow"
												
												aria-describedby="input-1-live-feedback"
											/>
											<!-- password -->
											<b-form-input v-if="attr.attrType == 'password'"
												:id="`input-${attr.attrName}`" v-model="form[attr.attrName]"
												type="password" class="form-control"
												:placeholder="$t(instanceClass + '.' + attr.attrName)"
												:required="attr.attrRequired"
												:readonly="dataMapShow.readOnlyShow"
												:class="{'is-invalid': (v$.form[attr.attrName] && v$.form[attr.attrName].$error), 'is-valid':(v$.form[attr.attrName] && !v$.form[attr.attrName].$error && v$.form[attr.attrName].$dirty)}"
												aria-describedby="input-1-live-feedback"
												autocomplete="new-password"
												@focus="isPasswordField = true"
											/>
											<!-- Integer -->
											<b-form-input v-if="attr.attrType == 'Integer'"
												:id="`input-${attr.attrName}`" v-model="form[attr.attrName]"
												type="number" class="form-control"
												:placeholder="$t(instanceClass + '.' + attr.attrName)"
												:required="attr.attrRequired"
												:readonly="dataMapShow.readOnlyShow"
												:class="{'is-invalid': (v$.form[attr.attrName] && v$.form[attr.attrName].$error), 'is-valid':(v$.form[attr.attrName] && !v$.form[attr.attrName].$error && v$.form[attr.attrName].$dirty)}"
												aria-describedby="input-1-live-feedback"
											/>
											<!-- Double inputmode="decimal"-->
											<b-form-input v-if="attr.attrType == 'Double'"
												:id="`input-${attr.attrName}`" v-model="form[attr.attrName]"
												type="number" class="form-control"
												step="any"
												:placeholder="$t(instanceClass + '.' + attr.attrName)"
												:required="attr.attrRequired"
												:readonly="dataMapShow.readOnlyShow"
												:class="{'is-invalid': (v$.form[attr.attrName] && v$.form[attr.attrName].$error), 'is-valid':(v$.form[attr.attrName] && !v$.form[attr.attrName].$error && v$.form[attr.attrName].$dirty)}"
												aria-describedby="input-1-live-feedback"
											/>

											<!-- CheckBoxString -->
											<div v-if="attr.attrType == 'CheckBoxString'">
												<b-form-checkbox-group
													id="checkbox-group-1"
													v-model="form[attr.attrName]"
													:options="attr.attrSelectList"
													:required="attr.attrRequired"
													:disabled="dataMapShow.readOnlyShow"
													:name="attr.attrName"
													:class="{'is-invalid': (v$.form[attr.attrName] && v$.form[attr.attrName].$error), 'is-valid':(v$.form[attr.attrName] && !v$.form[attr.attrName].$error && v$.form[attr.attrName].$dirty)}"

												/>
											</div>
											<!-- checkbox -->
											<b-form-checkbox-group v-if="attr.attrType == 'checkbox'"
												:id="`input-${attr.attrName}`" v-model="form[attr.attrName]"
												value-field="value" text-field="text"
												:options="[
													{ text: $t('boolean.true'),
														value: true,
														disabled: dataMapShow.readOnlyShow,
													},
													{ text: $t('boolean.false'),
														value: false,
														disabled: dataMapShow.readOnlyShow,
													},
												]"
												:name="attr.attrName"
												:required="attr.attrRequired"
												:class="{'is-invalid': (v$.form[attr.attrName] && v$.form[attr.attrName].$error), 'is-valid':(v$.form[attr.attrName] && !v$.form[attr.attrName].$error && v$.form[attr.attrName].$dirty)}"
												aria-describedby="input-1-live-feedback"
											/>
											<!-- radio -->
											<b-form-radio-group v-if="attr.attrType == 'radio'"
												:id="`input-${attr.attrName}`"
												v-model="form[attr.attrName]"
												value-field="value" text-field="text"
												:options="[
													{ text: $t('boolean.true'),
														value: true,
														disabled: dataMapShow.readOnlyShow,
													},
													{ text: $t('boolean.false'),
														value: false,
														disabled: dataMapShow.readOnlyShow,
													},
												]"
												:name="attr.attrName"
												:required="attr.attrRequired"
												:class="{'is-invalid': (v$.form[attr.attrName] && v$.form[attr.attrName].$error), 'is-valid':(v$.form[attr.attrName] && !v$.form[attr.attrName].$error && v$.form[attr.attrName].$dirty)}"
												aria-describedby="input-1-live-feedback"
											/>
											<datepicker 
												v-if="attr.attrType == 'Date'"
												v-model="form[attr.attrName]"
												:placeholder="$t(instanceClass + '.' + attr.attrName)"
												:required="attr.attrRequired"
												:disabled="dataMapShow.readOnlyShow"
												:language="language"
												calendar-class="rounded"
												:class="{'is-invalid': (v$.form[attr.attrName] && v$.form[attr.attrName].$error), 'is-valid':(v$.form[attr.attrName] && !v$.form[attr.attrName].$error && v$.form[attr.attrName].$dirty)}"
											/>
											<!-- DateInput -->	
											<b-form-input v-if="attr.attrType == 'DateInput'"
												:id="`input-${attr.attrName}`" v-model="form[attr.attrName]"
												type="date" class="form-control"
												:placeholder="$t(instanceClass + '.' + attr.attrName)"
												:required="attr.attrRequired"
												:readonly="dataMapShow.readOnlyShow"
												:class="{'is-invalid': (v$.form[attr.attrName] && v$.form[attr.attrName].$error), 'is-valid':(v$.form[attr.attrName] && !v$.form[attr.attrName].$error && v$.form[attr.attrName].$dirty)}"
												aria-describedby="input-1-live-feedback"
												format="DD/MM/YYYY"
											/>
											<!-- format="yyyy MMM dd" -->
											<!-- Select  && modalType != 'show'&& modalType != 'delete'-->
											<b-form-select v-if="attr.attrType == 'Select' "
												:id="`input-${attr.attrName}`" :name="attr.attrName"
												class="form-control"
												v-model="form[attr.attrName]" value-field="id"
												:text-field="attr.attrSelectOption"
												:options="attr.attrSelectList"
												:required="attr.attrRequired"
												:readonly="dataMapShow.readOnlyShow"
												:disabled="dataMapShow.readOnlyShow"
												:class="{'is-invalid': (v$.form[attr.attrName] && v$.form[attr.attrName].$error), 'is-valid':(v$.form[attr.attrName] && !v$.form[attr.attrName].$error && v$.form[attr.attrName].$dirty)}"
											/>
											<!-- SelectM -->
											<multiselect v-if=" attr.attrType == 'SelectM' 
												&& modalType != 'show' && modalType != 'delete'"
												:id="`input-${attr.attrName}`"
												:name="attr.attrName"
												:required="attr.attrRequired"
												:readonly="dataMapShow.readOnlyShow"
												v-model="form[attr.attrName]"
												:options="attr.attrSelectList"
												:multiple="true"
												:close-on-select="false"
												:clear-on-select="false"
												:preserve-search="true"
												:placeholder="$t(instanceClass + '.' + attr.attrName)"
												label="name"
												track-by="id"
												:preselect-first="false"
												:class="{'is-invalid': (v$.form[attr.attrName] && v$.form[attr.attrName].$error), 'is-valid':(v$.form[attr.attrName] && !v$.form[attr.attrName].$error && v$.form[attr.attrName].$dirty)}"
											>
												<template slot="selection" 
													slot-scope="{ values, isOpen }">
													<span class="multiselect__single" v-if="values.length && !isOpen">
														<h4 class="d-inline" v-if="values.length > 0">
															<b-badge v-for="dataSelected in values"
																:key="dataSelected.id" pill class="m-1" variant="success">
																{{ dataSelected ? dataSelected.name:
																$t("default.modal.no.role.selected")}}
															</b-badge>
														</h4>
													</span>
												</template>
											</multiselect>
											<!-- Multiple Select Show -->
											<div v-if="attr.attrType == 'SelectM' 
												&& modalType == 'show'" :id="`input-${attr.attrName}`"
												class="rounded" style="border: 1px solid #c5ccd6;background-color: #e0e5ec;" >
												<h4 class="d-inline">
													<b-badge v-for="selected in attr.attrSelectedList"
													:key="selected" pill class="m-1" variant="info">
														{{ selected ? selected : $t("default.modal.no.role") }}
													</b-badge>
												</h4>
											</div>

											<!-- File -->
											<input v-if="attr.attrType == 'File'" 
												ref="file" type="file"
												:lang="language"
												:multiple="true" class="form-control"
												:placeholder="$t('default.form.file.placeholder')"
												:drop-placeholder="$t('default.form.file.placeholder')"
												:required="attr.attrRequired"
												:readonly="dataMapShow.readOnlyShow"
												@change="handleFileUpload($event)"
												:class="{'is-invalid': (v$.form[attr.attrName] && v$.form[attr.attrName].$error), 'is-valid':(v$.form[attr.attrName] && !v$.form[attr.attrName].$error && v$.form[attr.attrName].$dirty)}"
											/>
											<!-- vuelidate -->
											<span class="small text-muted d-none d-md-block" v-if="v$.form[attr.attrName] && v$.form[attr.attrName].$error">
												{{ v$.form[attr.attrName].$errors[0].$message }}
											</span>
										</b-form-group>

									</div> <!--v-for="(attr, index) -->
								</div> <!--form-row -->
								
							</b-form>
						</b-container>
						<b-container v-if="modalType == 'delete'">
							<p>{{ $t("delete.confirm.message") }}</p>
						</b-container>
						<!-- <b-container v-if="modalType == 'trans'">
							<transcontent-form :transcontent="transcontent" />
						</b-container> -->
					</div>
					<div class="modal-footer">
						<div v-if="modalType !== 'show' && modalType !== 'delete' ">
							<!-- v-if=" instanceClass !== 'repmodel' && instanceClass !== 'notmessage' " 'repmodel', -->
							<b-button v-if="!['notmessage'].includes(instanceClass)" class="btn btn-success btn-sm" :disabled="loading" 
								@click="handleSubmit(dItemId)" >
								<span v-if=" !dItemId && modalType == 'new' && instanceClass !== 'repgismodel' && instanceClass !== 'notmessage'">
									<fa icon="add"/>
									{{ $t("default.button.create") }}
								</span>
								<span v-if="dItemId && (modalType == 'edit' || modalType == 'editPwd')">
									<fa icon="pencil"/>
									{{ $t("default.button.update")}}
								</span>
							</b-button>
						</div>
						<div v-if="dItemId && modalType == 'delete'">
							<b-button class="btn btn-danger btn-sm" :disabled="loading" 
								@click="axiosDel(dItemId)">
								<fa icon="trash"/>
								{{$t("default.button.delete")}}
							</b-button>
						</div>
						<!-- <div v-if="dItemId && modalType == 'trans'">
							<button @click="createtradLang()" class="btn btn-success btn-sm">
								<fa icon="check"/>&nbsp;
								{{ $t("default.button.translate") }}
							</button>
						</div> -->
						
						<div>
							<b-button class="btn btn-dark btn-sm" @click="modalToggle">
								<fa icon="times"/>
								{{ $t("default.button.close") }}
							</b-button>
						</div>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>
<script>
	import modalScriptMixin from "@/mixins/modalScriptMixin";
	import Multiselect from "vue-multiselect";
	import Datepicker from 'vuejs3-datepicker';
	// import TransContent from "@/components/utils/TransContent.vue";
	// import Ckeditor from '@ckeditor/ckeditor5-vue';
	import { useVuelidate } from '@vuelidate/core'
	import { required, email,minLength, maxLength } from '@vuelidate/validators'
	export default {
		name: "modal",
		setup () { return { v$: useVuelidate() }},
		mixins: [modalScriptMixin],
		components: {
			Multiselect,
			Datepicker,
			// Ckeditor,
			// 'transcontent-form' : TransContent,
		},
		props: {
			modalType: {
				type: String,
				required: true,
			},
			instanceClass: {
				type: String,
				required: true,
			},
			itemId: {
				type: Number,
				required: true,
			},
			attrTrans: {
				type: String,
				required: false,
			},
			
		},
		data() {
			return {
				active: false,
				// modal : true,
				dataMapShow: {
					infos: {},
					attrsList: [],
					readOnlyShow: false,
				},
				loading: false,
				dModalType: this.modalType,
				dItemId: this.itemId,

				/*datepicker: {
					selectedDate: "",
					selectedFormatted: "",
					locale: this.$i18n.locale,
					// messages: this.$i18n.messages[this.$i18n.locale].datepicker.labels,
				},*/
				/*optionsDatetimePicker: {
					// format: "YYYY-MM-DD HH:mm",
					//format: "YYYY-MM-DD HH:mm:ss z",
					format: "YYYY-MM-DDTHH:mmz",
					useCurrent: false,
					locale: this.$store.getters.language,
					icons: {
						time: "far fa-clock",
						date: "far fa-calendar",
						up: "fas fa-arrow-up",
						down: "fas fa-arrow-down",
						previous: "fas fa-chevron-left",
						next: "fas fa-chevron-right",
						today: "fas fa-calendar-check",
						clear: "far fa-trash-alt",
						close: "far fa-times-circle",
					},
				},*/
				form: {},
				file: [],
				transcontent: {},
				errors: [],
				// msgError: "",
				vueRules: {
					form: {}
				},

				editorConfig: {
					ckfinder: {
						uploadUrl: 'https://page.com/api/uploadckeditor'
					},
					toolbar: {
						items: [
							'heading',
							'|',
							'bold',
							'italic',
							'link',
							'bulletedList',
							'numberedList',
							'|',
							'outdent',
							'indent',
							'|',
							'imageUpload',
							'blockQuote',
							'insertTable',
							'mediaEmbed',
							'undo',
							'redo',
							'alignment',
							'codeBlock',
							'fontBackgroundColor',
							'fontColor',
							'fontFamily',
							'fontSize',
							'highlight',
							'horizontalLine',
							'htmlEmbed',
							'imageInsert',
							'pageBreak',
							'removeFormat',
							'strikethrough',
							'underline',
							'style'
						]
					},
					language: 'cs',
					image: {
						toolbar: [
							'imageTextAlternative',
							'imageStyle:inline',
							'imageStyle:block',
							'imageStyle:side',
							'imageStyle:alignLeft',
							'imageStyle:alignRight',
							'imageStyle:alignCenter',
							'imageStyle:alignBlockLeft',
							'imageStyle:alignBlockRight',
							'linkImage'
						]
					},
					table: {
						contentToolbar: [
							'tableColumn',
							'tableRow',
							'mergeTableCells',
							'tableCellProperties',
							'tableProperties'
						]
					},
					fontFamily: {
						options: [
							'default',
							'indieflowerregular',
							'Arial, sans-serif',
							'Verdana, sans-serif',
							'Trebuchet MS',
							'Apple Color Emoji',
							'Segoe UI Emoji',
							'Segoe UI Symbol',
						]
					},
					licenseKey: ''
				}
			}
		},
		validations () {
			return this.vueRules
		},
		created() {
			// util pour vuelidate rules
			this.initModal()
		},
		updated(){
			this.initModal()
		},
		methods:{
			initModal(){
				this.$store.dispatch('initFlash');
				this.language = this.$store.getters.language;
				this.dModalType = this.modalType || "new";
				this.dItemId = this.itemId || NaN;
				// if(this.dModalType == 'trans'){
				// 	this.transcontent.entityId = this.itemId;
				// 	this.transcontent.className = this.instanceClass;
				// 	this.transcontent.fieldName = this.attrTrans;
				// }
				// else
				this.axiosShow(this.dItemId, this.dModalType);
			},
			modalToggle() {
				this.resetModal()
				if(this.active)
					this.active = false
				else
					this.active = true 
			},
			handleFileUpload(e) { this.file = Array.from(e.target.files);},
			/*async createtradLang() {
				if (this.transcontent.id && this.transcontent.id !== "") {
					await this.$store.dispatch("axiosPut", {
						domain: "transcontent", id: this.transcontent.id, data: this.transcontent,
					})
					.then((response) => {
						// console.log("ACT - Succeess");
						// this.$bvModal.hide("modaltransContent");
						this.$emit('refreshDataTable', 'updated' );
						this.modalToggle()
						
					})
					.catch((error) => {
						this.transcontent = "edit";
					});
				} 
				else {
					await this.$store.dispatch("axiosPost", {
						domain: "transcontent", data: this.transcontent,
					})
					.then((response) => {
						this.$emit('refreshDataTable', 'created' );
						this.modalToggle()
					})
					.catch((error) => {
						this.transcontent = "create";
					});
				}
			},*/
		}

	}

</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>